export default __webpack_public_path__ + "static/media/audit-5.03870062.png";